<template>
	<div id="idFrmPan" ref="idFrmPan" style="display:flex; flex-direction:column; border:0px solid blue; height:100%;">
		<div style="flex: 0 0 auto; width:100%; height:50px; border:0px solid red;">
			<div class="SiftPanel" style="border:0px solid #bbbbbb;">
				<cselect style="position:relative; height:30px; min-width:120px; z-index:999; margin-left:20px;" :defv="findImgType" v-model="findImgType" :ctrl="ctrlImgType" :csData="dataImgType"></cselect>

				<cselect style="position:relative; height:30px; min-width:100px; z-index:999;" :defv="findPasterType" v-model="findPasterType" :ctrl="ctrlPasterType" :csData="dataPasterType"></cselect>

				<div class="Capt DIVNoSelect" style="flex:0 0 auto; margin-top:0px; margin-left:20px;">{{getLangText("素材名称")}}</div>
				<input type="text" style="width:120px;" v-model="findSourceName">

				<!--cselect style="position:relative; height:30px; min-width:150px; z-index:999; margin-left:20px;" :defv="findEquityLevel" v-model="findEquityLevel" :ctrl="ctrlEquityLevel" :csData="dataEquityLevel"></cselect-->

				<check style="height:30px; margin-right:10px; margin-left:20px;" :size="18" :grpName="cckName" :val="2" :capt="getLangText('私有')" :checked=true></check>
				<check style="height:30px; margin-right:20px;"                   :size="18" :grpName="cckName" :val="1" :capt="getLangText('共享')" :checked=false></check>

				<div class="NButton DIVNoSelect" style="width:32px; height:32px; background:url(../static/images/op_fin.png); margin-top:-1px; margin-left:10px;" @click="onSourceListClick"></div>
			</div>
		</div>
		<div style="flex: 1 0 auto; width:100%; height:100%; border:0px solid blue; display:flex; flex-direction:row; flex-wrap:wrap; overflow-y:auto;" id="idListPan" ref="idListPan">
			<div style="flex:0 0 auto; width:155px; height:177px; border:1px solid #bbbbbb; margin-left:40px; margin-top:20px; position:relative; z-index:900;" v-for="(curItem, index) in imgData" :index="index" @click="onSourceClick(curItem);">
				<div style="z-index:990; position:absolute; width:50px; height:50px; background:url(../static/images/publish3.png); background-size:100% 100%;" v-if="curItem.siCustId>0"></div>
				<div style="z-index:990; position:absolute; width:50px; height:50px; background:url(../static/images/publish2.png); background-size:100% 100%;" v-if="curItem.siCustId==0"></div>
				<div style="z-index:991; position:absolute; transform: rotate(-45deg) scale(0.7); left:-16px; top:8px; width:70px; height:20px; line-height:20px; border:0px solid red; color:#ffffff; text-align:center; font-size:14px;" class="DIVNoSelect">{{curItem.publicText}}</div>

				<div style="float:left; width:153px; height:22px; line-height:22px; text-align:center; border-bottom:1px solid #bbbbbb; font-size:12px;">{{ curItem.siNameEng }}</div>

				<div style="float:left; width:153px; height:153px; background:#bbbbbb; border:0px solid #bbbbbb;">
					<ImgThum :key="freshKey2+index" :item="curItem" :thW=144 :thH=144 style="float:left; border:0px solid red; width:100%; height:100%; cursor:pointer;"></ImgThum>
				</div>

				<!--div style="float:left; width:150px; height:100px; border:0px solid #bbbbbb;">
					<ImgThum :key="freshKey2+index" :item="curItem" :thW=150 :thH=100 style="cursor:pointer;"></ImgThum>
				</div-->
			</div>
		</div>
		<div style="flex: 0 0 auto; width:100%; height:30px; border:0px solid red;">
			<cpage :key="keyFind" :ctrl="ctrlPage" style="margin-left:0px;"></cpage>
		</div>
	</div>
</template>

<script>

import ImgThum    from './ImgThum'
import cselect    from '../cf/cselect'
import check      from '../cf/cck'
import cpage      from '../cf/cpage'

export default {
	name: 'TemplaSetSource',
	components:{
		ImgThum, cselect, check, cpage
	},
	data () {
		return {
			frmW: 0,
			frmH: 0,
			freshKey2: 2000,
			keyFind: 1,
			ctrlPage: {
				havNote: true,                  //是否显示提示信息
				havGo: true,                    //是否显示页号输入及按钮
				total: 0,                       //总记录数
				pageSize: 15,                   //每页记录条数
				pageIdx: 0,                     //当前页码
				cont:[LangText('共'), LangText('条记录,'), LangText('页'), LangText('条/页'), LangText('页码'),'Go'],
				qryFunc: this.onSourceListClick,      //查询回调函数
			},
			imgData:[],                           // 素材列表

			findSourceName: "",                   // 素材名称
			findImgType: "",                      // 素材类型
			ctrlImgType: {
				itemHeight: 26,
				bgClr: "#ffffff",
				bodr: "#cccccc",
				expandEmp: false,
				size: 3,
				Removefirst: true,
			},
			findPasterType: "160",                   // 贴纸类型
			ctrlPasterType: {
				itemHeight: 26,
				bgClr: "#ffffff",
				bodr: "#cccccc",
				expandEmp: false,
				size: 10
			},
			findEquityLevel: "132",                   // 权益等级
			/*ctrlEquityLevel:{
				itemHeight: 26,
				bgClr: "#ffffff",
				bodr: "#cccccc",
				expandEmp: false,
				size: 10
			},*/
			cckName: "id."+this.getUIID(),         // 复选框唯一ID
		}
	},
	mounted: function(){
		this.frmW=this.$refs["idFrmPan"].clientWidth;
		this.frmH=this.$refs["idFrmPan"].clientHeight;
		this.$refs["idListPan"].style["height"] = (this.frmH-80)+"px";

		this.findImgType    = this.$route.query.ty1;
		this.findPasterType = this.$route.query.ty2;

		this.ctrlImgType.self.setDisabled( true );
		this.ctrlPasterType.self.setDisabled( true );

		this.onSourceListClick();
	},
	watch:{

	},
	computed:{

	},
	methods:{
		onResize: function(){
			this.frmW=this.$refs["idFrmPan"].clientWidth;
			this.frmH=this.$refs["idFrmPan"].clientHeight;

			if( this.frmH > 0 ) this.$refs["idListPan"].style["height"] = (this.frmH-80)+"px";

			this.childResize( this );
		},
		onSourceListClick: function(){
			let body={ pageSize:this.ctrlPage.pageSize, curPage:this.ctrlPage.pageIdx-1, siCustId:this.login.custId, siNameEng:this.findSourceName,
						siImgType:parseInt(this.findImgType) };
			body.siPasterType = parseInt(this.findPasterType);
			body.siEquityLevel = parseInt(this.findEquityLevel);

			let v=this.getCheckValuesByName( this.cckName );

			if( v=="1,2" || v=="2,1" )
				 body.custRange = 3;
			else body.custRange = parseInt(v);

			this.doTrade( "POST", ServAddr+"/api/source/sourceList", this.onSourceListOK, true, body, null );
		},
		onSourceListOK: function( res ){
			this.appRoot.app.closeDlgRun();

			let data=res.body;
			if( data.code != "200" )
			{
				this.appRoot.app.showDlgTip( 1200, this.getErrorText(data.code), this.CLR.Err );
				return;
			}

			this.imgData = [];
			for(let i=0; i<data.body.sourceList.length; i++ )
			{
				let item=data.body.sourceList[i];
				let img={};
				img.siCustId      = item.siCustId;
				img.siNameEng     = item.siNameEng;
				img.siId          = item.siId;
				img.width         = item.siSize.split(",")[0];
				img.height        = item.siSize.split(",")[1];
				img.siUsedTimes   = item.siUsedTimes;
				img.siEquityLevel = item.siEquityLevel;
				img.siEquityText  = this.getEquityText(item.siEquityLevel);
				img.siImgType     = item.siImgType;
				img.siPasterType  = item.siPasterType;
				img.siVerno       = item.siVerno;
				img.path          = item.siImgPath;
				img.areas         = [];
				if( img.siCustId == 0 )
					 img.publicText = LangText("共享");
				else img.publicText = LangText("私有");

				this.imgData.push( img );
			}
			this.freshKey2 = this.freshKey2 + 1000;
			this.ctrlPage.total = data.body.sourceList.length;
			this.keyFind++;
		},
		onSourceClick: function( item ){
			this.$parent.onPopWinClose( true, {siId:item.siId, path:item.path} );
		},
	}
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// TemplaSetSource.vue?4752be4b